import { CustomerDto, defaultCustomerDto } from "src/dtos/customer/customerDto";

export interface MST2010_R01Dto extends CustomerDto {
	searchText?: string;
	listLength?: number;
	refetchListLength?: number;
	customCd: string;  // 거래처 코드
	customNm: string;  // 상호
	customNmFull: string;
	regNo: string;   // 사업자번호
	owner: string;   // 대표자
	areaCd: string;  // 관리지역
	customType: string;  // 거래유형
	telNo: string;   // 전화번호
	address: string; // 주소
	detailAddress: string;
	taxEmail: string;
	taxTelNo: string;
	post: string;
	faxNo: string;   // 팩스
	businessType: string;  // 업태
	businessClass: string; // 종목
	moneyCd: string;
	remark: string;

	inserted: boolean;
	isModified: boolean;
  }

export const defaultMST2010_R01Dto: MST2010_R01Dto = { 
	...defaultCustomerDto,
	searchText: '',
	listLength: 0,
	refetchListLength: 0,
	customCd: "",
	customNm: "",
	regNo: "",
	owner: "",
	areaCd: "",
	customType: '',
	telNo: "",
	address: "",
	faxNo: "",
	businessType: "",
	businessClass: "",
	customNmFull: '',
	detailAddress: '',
	taxEmail: '',
	taxTelNo: '',
	post: '',
	moneyCd: '',
	remark: '',
	
	inserted: false,
	isModified: false,
  }
